require('../../modules/es6.string.iterator');

require('../../modules/web.dom.iterable');

module.exports = require('../../modules/_wks-ext').f('iterator');